import { DSButton } from '@demandstar/components/button';

interface FileUploadBoxProps {
  fileName: string;
  isDragging: boolean;
  fileError: string;
  fileInputRef: React.RefObject<HTMLInputElement>;
  onDragOver: (e: React.DragEvent) => void;
  onDragLeave: () => void;
  onDrop: (e: React.DragEvent) => void;
  onFileChange: (files: FileList | null) => void;
  onReset: () => void;
}

export function FileUploadBox({
  fileName,
  isDragging,
  fileError,
  fileInputRef,
  onDragOver,
  onDragLeave,
  onDrop,
  onFileChange,
  onReset,
}: FileUploadBoxProps) {
  if (!fileName) {
    return (
      <div className='upload-box'>
        <p>
          {isDragging ? (
            <span className='text-success'>Drop your file here</span>
          ) : (
            'Drag & drop your file here'
          )}
        </p>
        <p>or</p>
        <DSButton onClick={() => fileInputRef.current?.click()}>Upload File</DSButton>
        {fileError && <p className='text-danger mt-2'>{fileError}</p>}
        <input type='file' hidden ref={fileInputRef} onChange={e => onFileChange(e.target.files)} />
      </div>
    );
  }

  return (
    <div className='mb-3 upload-box'>
      <b>
        {' '}
        {fileName}
        <span className='ml-2 text-danger mdi mdi-delete-outline delete-icon' onClick={onReset} />
      </b>
      <p className='mt-4 text-muted'>File ready for Analysis</p>
      <p className='text-muted'>
        You can upload another file if you want to change the document by removing the current one.
      </p>
    </div>
  );
}
